import React from "react";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import { Day, TimeRange } from "./types";

interface DeleteEventConfirmDialogProps {
  day: Day;
  event: TimeRange;
  onConfirm: () => void;
  onCancel: () => void;
}

// Diálogo de confirmación reutilizable para eliminar una franja horaria,
// compartido entre las vistas de escritorio y móvil del WeeklyCalendar.
const DeleteEventConfirmDialog: React.FC<DeleteEventConfirmDialogProps> = ({
  day,
  event,
  onConfirm,
  onCancel,
}) => (
  <ConfirmDialog
    open
    danger
    title="Eliminar franja horaria"
    label={
      <>
        ¿Seguro que quieres eliminar la franja de <strong>{day.fullLabel}</strong>{" "}
        de <strong>{event[0]}</strong> a <strong>{event[1]}</strong>?
      </>
    }
    confirmLabel="Eliminar"
    cancelLabel="Cancelar"
    onConfirm={onConfirm}
    onCancel={onCancel}
  />
);

export default DeleteEventConfirmDialog;
